import { render, staticRenderFns } from "./ReportImageCockpitDetail.vue?vue&type=template&id=c1b6c4aa&"
import script from "./ReportImageCockpitDetail.vue?vue&type=script&lang=ts&"
export * from "./ReportImageCockpitDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageCockpitDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
